import accounting from 'accounting';

const formatMoney = function(amount = '0', units = 2) {
  const stringAmount = amount.toString();
  const pointPosition = stringAmount.indexOf('.');
  const fractionalPartLength =
    pointPosition === -1 ? 0 : stringAmount.length - pointPosition - 1;
  const scale = Math.max(units, fractionalPartLength);

  return accounting.formatNumber(amount, scale, '.', ',');
};

const truncate = function (fullStr, mode, strLength, sep) {
  let truncated = ''
  const DEFAULT_STR_LENGTH = 20,
    START_INDEX_OF_STRING = 0,
    DEFAULT_MODE = 'center',
    DEFAULT_SEPARATOR = '...',
    CHARS_DIVIDER = 2,
    strLen = strLength || DEFAULT_STR_LENGTH;

  if (fullStr.length <= strLen) {
    return fullStr;
  }

  const separator = sep || DEFAULT_SEPARATOR;
  const trancationMode = mode || DEFAULT_MODE;

  const sepLen = separator.length,
    charsToShow = strLen - sepLen,
    frontChars = Math.ceil(charsToShow / CHARS_DIVIDER),
    backChars = Math.floor(charsToShow / CHARS_DIVIDER);

  switch (trancationMode) {
    case 'center':
      truncated =
        fullStr.substr(START_INDEX_OF_STRING, frontChars) +
        separator +
        fullStr.substr(fullStr.length - backChars)
      break

    case 'start':
      truncated =
        fullStr.substr(START_INDEX_OF_STRING, frontChars + backChars) +
        separator
      break

    case 'end':
      truncated =
        separator +
        fullStr.substr(START_INDEX_OF_STRING, frontChars + backChars)
      break
    default:
      return
  }

  return truncated
};

const join = function(value, glue = ', ') {
  return value.join(glue);
};

const isEmpty = function(value) {
  return value === undefined || value === '' || value === null;
};

const ucfirst = function(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export { formatMoney, truncate, join, isEmpty, ucfirst };
